import React, { createContext, useState, useEffect, useContext } from "react";
import { usePermission as useAPI } from "../queries/use-permission";

const PermissionContext = createContext();

const { Provider } = PermissionContext;

const usePermission = () => useContext(PermissionContext);

const PermissionProvider = ({ children, projectId }) => {
  const { isLoading, data: permission } = useAPI(projectId);
  const isAdmin = Boolean(permission?.isMember);

  const hasPermission = Boolean(
    permission?.isMember || permission?.contributor
  );
  const hasAdminRight = Boolean(permission?.isMember);

  return (
    <Provider
      value={{
        permission,
        isAdmin,
        hasAdminRight,
      }}
    >
      {/* eslint-disable-next-line no-nested-ternary */}
      {!isLoading ? hasPermission ? children : <div>No Permission</div> : null}
    </Provider>
  );
};

export { PermissionProvider, usePermission };
